import * as templates from 'apps/templates/actions/templatesActions'

export default { templates }
